import { type FC } from "react";
import type { PlainEditor } from "@/queries/editor-queries";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { IntelliJLogo } from "@/assets/logos/IntelliJLogo";
import { GoLandLogo } from "@/assets/logos/GoLandLogo";
import { PyCharmLogo } from "@/assets/logos/PyCharmLogo";
import { PhpStormLogo } from "@/assets/logos/PhpStormLogo";
import { RubyMineLogo } from "@/assets/logos/RubyMineLogo";
import { WebStormLogo } from "@/assets/logos/WebStormLogo";
import { CLionLogo } from "@/assets/logos/CLionLogo";
import { RustRoverLogo } from "@/assets/logos/RustRoverLogo";
import { RiderLogo } from "@/assets/logos/RiderLogo";
import { VSCodeLogo } from "@/assets/logos/VSCodeLogo";
import { VSCodeInsidersLogo } from "@/assets/logos/VSCodeInsidersLogo";
import { CursorLogo } from "@/assets/logos/CursorLogo";
import type { Size } from "@/assets/icons/geist/Size";
import { WindsurfLogo } from "@/assets/logos/WindsurfLogo";

export const EditorIcon: FC<{ editor: PlainEditor; size: Size } & PropsWithClassName> = ({
    editor,
    size,
    className,
}) => {
    let ComputedEditorLogo: React.ComponentType<PropsWithClassName>;
    switch (editor.alias) {
        case "vscode":
            ComputedEditorLogo = VSCodeLogo;
            break;
        case "vscode-insiders":
            ComputedEditorLogo = VSCodeInsidersLogo;
            break;
        case "cursor":
            ComputedEditorLogo = CursorLogo;
            break;
        case "windsurf":
            ComputedEditorLogo = WindsurfLogo;
            break;
        case "idea":
            ComputedEditorLogo = IntelliJLogo;
            break;
        case "goland":
            ComputedEditorLogo = GoLandLogo;
            break;
        case "pycharm":
            ComputedEditorLogo = PyCharmLogo;
            break;
        case "phpstorm":
            ComputedEditorLogo = PhpStormLogo;
            break;
        case "rubymine":
            ComputedEditorLogo = RubyMineLogo;
            break;
        case "webstorm":
            ComputedEditorLogo = WebStormLogo;
            break;
        case "clion":
            ComputedEditorLogo = CLionLogo;
            break;
        case "rustrover":
            ComputedEditorLogo = RustRoverLogo;
            break;
        case "rider":
            ComputedEditorLogo = RiderLogo;
            break;
        default:
            ComputedEditorLogo = VSCodeLogo;
    }

    return (
        <ComputedEditorLogo
            className={cn(
                className,
                size === "sm" && "size-[16px]",
                size === "base" && "size-[20px]",
                size === "lg" && "size-[24px]",
            )}
        />
    );
};
